import { render } from "./GraphControls.vue?vue&type=template&id=795e60df&scoped=true&ts=true"
import script from "./GraphControls.vue?vue&type=script&lang=ts"
export * from "./GraphControls.vue?vue&type=script&lang=ts"

import "./GraphControls.vue?vue&type=style&index=0&id=795e60df&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795e60df"]])

export default __exports__